import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// 3rd party
import { RxReactiveDynamicFormsModule } from '@rxweb/reactive-dynamic-forms';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { NgxLoadingModule } from 'ngx-loading';
// Modules
import { SharedModule } from '../../../shared/shared.module';
import { WifiRoutingModule } from './wifi-routing.module';
// Components
import { ClientsComponent } from './clients/clients.component';
import { ActivityListComponent } from './clients/modal/activity-list/activity-list.component';
import { AdsComponent } from './ads/ads.component';
import { AdsEditCreateComponent } from './ads/modal/edit-create/edit-create.component';
import { FormService } from '../../../shared/services/form.service';

@NgModule({
    declarations: [
        ClientsComponent,
        ActivityListComponent,
        AdsComponent,
        AdsEditCreateComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RxReactiveFormsModule,
        RxReactiveDynamicFormsModule,
        SharedModule,
        WifiRoutingModule
    ],
    providers: [
        FormService
    ]
})
export class WifiModule { }
